import { TezosToolkit } from '@taquito/taquito';
import { BeaconWallet } from '@taquito/beacon-wallet';
import { Tzip16Module, tzip16 } from '@taquito/tzip16';
import { NetworkType } from '@airgap/beacon-sdk';

document.addEventListener('DOMContentLoaded', () => {
  const Tezos = new TezosToolkit('https://mainnet.smartpy.io');
  Tezos.addExtension(new Tzip16Module());

  const wallet = new BeaconWallet({ 
    name: 'Tezos Operator Manager',
    preferredNetwork: NetworkType.MAINNET
  });
  
  Tezos.setWalletProvider(wallet);

  const loadTokensBtn = document.getElementById('loadTokensBtn');
  const checkOperatorBtn = document.getElementById('checkOperatorBtn');
  const tokensTableContainer = document.getElementById('tokensTableContainer');

  let contractInstance = null;
  let tokensOwners = {};
  let operator = null;

  const sendBatchBtnTop = document.createElement('button');
  sendBatchBtnTop.textContent = 'Send Update Operators Batch';
  sendBatchBtnTop.disabled = true;
  tokensTableContainer.parentElement.insertBefore(sendBatchBtnTop, tokensTableContainer);

  loadTokensBtn.onclick = loadTokensAndOwners;
  checkOperatorBtn.onclick = checkOperatorStatus;
  sendBatchBtnTop.onclick = sendUpdateOperators;

  async function ensureWalletConnected() {
    const activeAccount = await wallet.client.getActiveAccount();
    if (!activeAccount) {
      await wallet.requestPermissions();
    }
  }

  async function loadTokensAndOwners() {
    const contractAddress = document.getElementById('contractSelect').value;
    if (!contractAddress) return alert('Please enter a contract address');

    try {
      await ensureWalletConnected();
      contractInstance = await Tezos.wallet.at(contractAddress, tzip16);

      const response = await fetch(
        `https://api.tzkt.io/v1/tokens/balances?token.contract=${contractAddress}&balance.ne=0&limit=1000`
      );
      const balances = await response.json();

      tokensOwners = {};
      balances.forEach(b => {
        const tokenId = Number(b.token.tokenId);
        if (!tokensOwners[tokenId]) tokensOwners[tokenId] = [];
        tokensOwners[tokenId].push(b.account.address);
      });

      renderTokensTable(tokensOwners);

      checkOperatorBtn.disabled = false;
      sendBatchBtnTop.disabled = true;
      operator = null;
    } catch (e) {
      alert('Failed to load tokens and owners: ' + e.message);
    }
  }

  async function checkOperatorStatus() {
    operator = document.getElementById('operatorAddress').value.trim();
    if (!operator) return alert('Please enter an operator address');
    if (!contractInstance) return alert('Please load tokens and owners first');

    const contractAddress = document.getElementById('contractSelect').value;
    await ensureWalletConnected();

    try {
      const tzktUrl = `https://api.tzkt.io/v1/contracts/${contractAddress}/bigmaps/operators/keys?limit=10000`;
      const response = await fetch(tzktUrl);
      const operatorsData = await response.json();

      const operatorSet = new Set();
      operatorsData.forEach(entry => {
        const key = entry.key;
        const lookupKey = `${key.owner}-${key.operator}-${key.token_id}`;
        operatorSet.add(lookupKey);
      });

      const checkboxes = tokensTableContainer.querySelectorAll('input[type=checkbox]:not(#selectAllCheckbox)');

      for (const cb of checkboxes) {
        const [tokenIdStr, owner] = cb.value.split('/');
        const tokenId = tokenIdStr;
        
        const lookupKey = `${owner}-${operator}-${tokenId}`;
        const isOpResult = operatorSet.has(lookupKey);

        if (isOpResult) {
          cb.checked = true;
          cb.disabled = true;
          cb.parentElement.classList.add('disabled');
          let msgSpan = cb.parentElement.querySelector('.operator-message');
          if (!msgSpan) {
            msgSpan = document.createElement('span');
            msgSpan.classList.add('operator-message', 'operator-enabled');
            cb.parentElement.appendChild(msgSpan);
          }
          msgSpan.textContent = ' ✓ Operator already enabled';
        } else {
          cb.checked = false;
          cb.disabled = false;
          const msgSpan = cb.parentElement.querySelector('.operator-message');
          if (msgSpan) msgSpan.remove();
          cb.parentElement.classList.remove('disabled');
        }
      }

      sendBatchBtnTop.disabled = false;
    } catch (err) {
      alert('Failed to check operator status: ' + err.message);
    }
  }

  async function sendUpdateOperators() {
    if (!operator) return alert('Please enter an operator address');
    if (!contractInstance) return alert('Please load tokens and owners first');

    const checkboxes = tokensTableContainer.querySelectorAll('input[type=checkbox]:checked:not(#selectAllCheckbox)');
    if (checkboxes.length === 0) return alert('No operators selected to update');

    try {
      await ensureWalletConnected();

      const updateOps = Array.from(checkboxes).map(cb => {
        const [tokenIdStr, owner] = cb.value.split('/');
        return {
          add_operator: {
            owner: owner,
            operator: operator,
            token_id: parseInt(tokenIdStr)
          }
        };
      });

      const op = await contractInstance.methodsObject.update_operators(updateOps).send();
      alert(`Transaction sent with hash: ${op.opHash}`);
      
      await op.confirmation();
      alert('Transaction confirmed!');
      
      // Re-check operator status after successful transaction
      await checkOperatorStatus();
      
    } catch (e) {
      let errorMsg = e.message || e.toString() || 'Unknown error';
      alert('Failed to send batch update_operators: ' + errorMsg);
    }
  }

  function renderTokensTable(tokensOwners) {
    tokensTableContainer.innerHTML = '';

    const table = document.createElement('table');
    const headerRow = document.createElement('tr');
    headerRow.innerHTML =
      '<th>Token ID / Name</th><th>Owners (Select to Add Operator) <input type="checkbox" id="selectAllCheckbox" title="Select All Enabled" /></th>';
    table.appendChild(headerRow);

    for (const tokenId in tokensOwners) {
      const owners = tokensOwners[tokenId];
      const row = document.createElement('tr');

      const tokenCell = document.createElement('td');
      tokenCell.textContent = tokenId;
      row.appendChild(tokenCell);

      const ownersCell = document.createElement('td');

      owners.forEach(owner => {
        const label = document.createElement('label');
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.disabled = true;
        checkbox.value = `${tokenId}/${owner}`;
        label.appendChild(checkbox);
        label.appendChild(document.createTextNode(owner));
        ownersCell.appendChild(label);
        ownersCell.appendChild(document.createElement('br'));
      });

      row.appendChild(ownersCell);
      table.appendChild(row);
    }

    tokensTableContainer.appendChild(table);

    const selectAll = document.getElementById('selectAllCheckbox');
    selectAll.addEventListener('change', () => {
      const checkboxes = tokensTableContainer.querySelectorAll(
        'input[type=checkbox]:not(#selectAllCheckbox):not(:disabled)'
      );
      checkboxes.forEach(cb => {
        cb.checked = selectAll.checked;
      });
    });
  }
});